// extracted by mini-css-extract-plugin
module.exports = {"button":"cardModalCategoiesInfo_button__ZavIh","container":"cardModalCategoiesInfo_container__nnK5X","explanationBlock":"cardModalCategoiesInfo_explanationBlock__890Oh"};